export default [
    {
        title: "成功案例",
        content:
            "用专业的态服务客户，每一次项目都是新的经验累积，以最专业的态度对待每一次客户交给我们的项目"
    },
    {
        title: "团队介绍",
        content:
            "优秀的团队服务客户，优秀的团队优质的出品，团队，拥有专业的技术人员跟销售人员，让每一个项目更加出彩"
    },
    {
        title: "定制服务",
        content:
            "针对不同的客户，我们推出了独一无二的定制服务，满足不同客户的需求，专业的对接，专业的团队，优质的出品"
    }
];
